module.exports = function (gantt) {
  delete gantt.addTaskLayer;
  delete gantt.addLinkLayer;
};